module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Besenbueren-799b505e74e49bb0dcbdd6b759d842ef.svg";